import React from 'react';
import styled, { css } from 'styled-components';

import { Logo } from '@sayido/ui';

const TOP_OFFSET = 120;
const MOBILE_BREAKPOINT = 740;

const linkStyles = css`
  padding: 1.5rem;
  font-size: 16px;
  flex:1;
  white-space: nowrap;
  text-align: center;
  color:rgb(110, 110, 110);
  position: relative;
  display: block;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;

  ${props =>
    props.primary
      ? `background: var(--primary-500);padding: 1.5rem 2rem;color:#fff !important;opacity:1!important;border-radius: 4px;margin-left: 12px;font-weight: bold; &:hover {background: var(--primary-500);box-shadow:0px 3px 16px 0px rgba(62, 57, 107, 0.3);transform:translateY(-1px)}`
      : ``}

    @media(max-width: ${MOBILE_BREAKPOINT + 200}px) {
      padding: 1.5rem 0.8rem;
    }
  `;

const NavLink = styled('a')`
  ${linkStyles}
`;

const Wrapper = styled.nav`
  box-shadow: 0px 9px 68px 0px rgba(62, 57, 107, 0.1);
  background: #fff !important;
  box-sizing: border-box;
  padding: 20px;
  position: ${p => (p.sticky ? 'fixed' : 'relative')};
  width: 100vw;
  top: 0;
  transition: all 0.3s ease;
  z-index: 50;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 0px 20px;
  }
`;

const Inner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1140px;
  margin: 0 auto;
  flex-wrap: nowrap;
  padding: 0 20px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 0;
  }

  .nav-logo {
    width: 150px;

    @media (max-width: ${MOBILE_BREAKPOINT}px) {
      width: 120px;
    }
  }
`;

const Collapse = styled.div`
  display: flex;
  flex-grow: 1;
  flex-basis: auto;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: ${props => (props.isOpen ? 'flex' : 'none')};
    position: absolute;
    z-index: 100;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    padding: 40px 0;
    box-shadow: 0px 25px 40px 0px rgba(62, 57, 107, 0.1);

    &:after {
      // content: " ";
      background: #fff;
      bottom: 0px;
      height: 20px;
      box-shadow: 0px 9px 68px 0px rgba(62, 57, 107, 0.3);
      width: 100%;
      position: absolute;
      left: 0;
      z-index: -1;
    }
  }
`;

const NavList = styled.ul`
  display: flex;
  flex-direction: row;
  margin: 0;
  margin-left: auto !important;
  padding: 0;
  list-style: none;
  justify-content: space-between;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    flex-direction: column;
    justify-content: stretch;
    width: auto;
    margin: 0 auto;
  }
`;

const MenuBtn = styled.button`
  border: none;
  background: transparent;
  height: 54px;
  width: 54px;
  position: relative;

  @media (min-width: ${MOBILE_BREAKPOINT - 1}px) {
    display: none;
  }

  &:before {
    content: ' ';
    border-bottom: solid 2px #444;
    width: 24px;
    height: 0;
    transform: ${props => (props.isOpen ? 'rotate(45deg) translate(3%,-152%)' : '')};
    position: absolute;
    top: 46%;
    transform-origin: center;
  }
  &:after {
    border-bottom: ${props => (!props.isOpen ? 'solid 2px #444' : 'none')};
    border-top: solid 2px #444;
    width: 24px;
    height: 14px;
    content: ' ';
    top: 32%;
    transform: ${props => (props.isOpen ? 'rotate(-45deg) translate(12%,48%)' : '')};
    position: absolute;
    transform-origin: center;
  }

  &:focus {
    outline: none;
  }
`;

const NavItem = styled.li`
  flex: 1;
`;

export const Navbar = ({ sticky = true, navItems = [], cta = null }) => {
  // const [isOpen, setIsOpen] = useState(false);
  // const [isSticky, setIsSticky] = useState(false);

  return (
    <Wrapper
      sticky={sticky}
      // isSticky={this.state.isSticky}
    >
      <Inner>
        <Logo className="nav-logo" src={Logo} alt="Say I do" size="150" />

        <MenuBtn
          // isOpen={this.state.isOpen}
          onClick={() => {
            // this.setState({ isOpen: !this.state.isOpen });
          }}
        />
        <Collapse
        // isOpen={this.state.isOpen}
        >
          <NavList>
            {navItems.map(navItem => {
              return navItem;
            })}
          </NavList>
        </Collapse>
      </Inner>
    </Wrapper>
  );
};
